export interface SectorDTO {
    sector: number | null;
    name: string | null;
    shortname: string | null;
    repositorytypedescription: string | null;
    externalcode: string | null;
    active: boolean;
    acceptpatienttransfers: boolean;
    restrictroomgendercontrol: boolean;
    sectortypedescription: string | null;
    prescriptionpriority: number | null;
    parentsector: number | null;
    parentsectorname: string | null;
    building: number | null;
    buildigname: string | null;
    buildingaddress: string | null;
    beds: number | null;
    bed: number | null;
  }
  
  export const defaultSectorDTO: SectorDTO = {
    sector: -1,
    name: '<Todos>',
    shortname: '<Todos>',
    repositorytypedescription: '<Todos>',
    externalcode: null,
    active: false,
    acceptpatienttransfers: false,
    restrictroomgendercontrol: false,
    sectortypedescription: null,
    prescriptionpriority: null,
    parentsector: null,
    parentsectorname: null,
    building: null,
    buildigname: null,
    buildingaddress: null,
    beds: null,
    bed: null,
  };
  